import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe to capitalize the first character of the first word a string
 * @class CapitalizePipe
 * @typedef {CapitalizePipe}
 * @implements {PipeTransform}
 */
@Pipe( {
    name: 'capitalize'
} )
export class CapitalizePipe implements PipeTransform {

    /**
     * helper function to capitalize the first character of a text string
     * @param {string} text
     * @param {...unknown[]} args
     * @returns {unknown}
     */
    transform( text: string, ...args: unknown[] ): unknown {
        const splitString = text.split( ' ' );
        const firstWord = splitString.shift();
        const capitalizedWord = `${firstWord!.slice( 0, 1 ).toUpperCase()}${firstWord!.slice( 1 )}`;
        splitString.unshift( capitalizedWord );

        return splitString.join( ' ' );
    }

}
